const TRANSLATION = {
  buyModal: {
    afterFree: 'После бесплатной пробной версии',
    btn: 'Попробуйте бесплатно',
    freeTrial: '3-дневная бесплатная пробная версия',
    monthLabel: 'месяц',
    selectLabel: 'Выберите план',
    title: 'План подписки',
    yearLabel: 'год',
  },
  contact: {
    block1:
      'Для настройки, вопросов или предложений, пожалуйста, свяжитесь с нами по адресу contact@noam.tools. Мы ответим быстро.',
    block2: 'Поддержите нас, оценив нас в магазине расширения Google Apps по адресу ★★★★★.',
    block3: 'Помогите другим, поделившись этим расширением:',
    title: 'Связаться с нами',
  },
  help: {
    AquickOverviewOfNoam: 'Быстрый обзор Ноама',
    ChatPDF: 'Чат PDF',
    ChatPDF2: 'Chatpdf',
    FavoritesManagement: 'Фавориты управления',
    Fixedplugin: 'Фиксированный плагин',
    Focusing: 'Фокусировка',
    Free: 'Бесплатно',
    FreeTrialBenefits: 'Бесплатные пробные пособия',
    GoWithWikipedia: 'Пойти с Википедией',
    GoWithYouTube: 'Идите с YouTube',
    HoverTranslation: 'Перевод Hover',
    Howtouse: 'Как использовать',
    ImageTranslation: 'Перевод изображения',
    InstantTranslation: 'Мгновенный перевод',
    Membership: 'Членство',
    NoamHelp: 'Ноам поможет вам перевести и суммировать',
    PDFparallelTranslation: 'PDF Параллельный перевод',
    ParallelTranslation: 'Параллельный перевод',
    SkipAllSteps: 'Пропустите все шаги',
    Summary: 'Краткое содержание',
    Translation: 'Перевод',
    TryItForFree: 'Попробуйте бесплатно',
    Video: 'Видео',
    VideoSummary: 'Видео -краткое изложение',
    VideoTranslation: 'Видео перевод',
    WebSummary: 'Сводная информация',
    WordSelectionTranslation: 'Перевод выбора слов',
    benefits: 'У нас есть преимущества ждать вас!',
    dayFree: '3-дневная бесплатная пробная версия',
    done: 'Сделанный',
    next: 'Следующий',
    pin: 'PIN NOAM для более легкого доступа ～～',
    planIsNotExist: 'План недоступен',
    startWiki: 'Давайте начнем с Wikimedia!',
    startYoutube: 'Начнем с YouTube!',
    try: 'Попробуйте это',
    tryNow: 'Попробуйте сейчас!',
  },
  home: {
    PDFTranslate: {
      desc: 'Двуязычный перевод + чат pdf',
      sub1: {
        desc: 'Двуязычное чтение позволяет сравнить исходный текст и перевод бок о бок, повышая эффективность чтения.',
        title: 'Двуязычное чтение',
      },
      sub2: {
        desc: 'ИИ анализирует и суммирует, и может ответить на ваши вопросы на основе содержания PDF.',
        title: 'Чат PDF',
      },
      sub3: {
        desc: 'AI-двигательный PDF-перевод для большей точности и эффективности.',
        title: 'Точность и эффективность',
      },
      title: 'PDF Перевод',
    },
    aiAssistant: {
      desc: 'Сделать веб -перевод более умным и удобным',
      panel1: {
        desc: 'Двуязычные переводы перекрестных привязки помогут вам сравнить исходный текст с переводом, чтобы вы могли лучше понять и повысить эффективность чтения.',
        title: 'Двуязычный перевод',
      },
      panel2: {
        left: {
          desc: 'При просмотре веб -страницы наведите на контент, необходимый для перевода, чтобы увидеть перевод.',
          title: 'Перевод Hover',
        },
        right: {
          desc: 'При просмотре веб -страницы выберите текст, который вы хотите перевести, чтобы увидеть перевод.',
          title: 'Текст выбора перевода',
        },
      },
      panel3: {
        one: {
          desc: 'Перевести и суммировать веб -страницы и видеоконтент в любое время, где угодно, для более плавного опыта!',
          title: 'Точка и нажмите',
        },
        three: {
          desc: 'Большая языковая модель, управляемая ИИ, обеспечивает точность и последовательность перевода для улучшенного опыта чтения.',
          title: 'AI-управляемый',
        },
        two: {
          desc: 'Полное покрытие с несколькими языками, двуязычное чтение без барьеров, перевод в один щелчок-испытайте разницу!',
          title: 'Более всеобъемлющий и удобный',
        },
      },
      panel4: {
        tab1: {
          desc: 'Ваш эксперт по эффективности - Используя CHATGPT, NOAM переводится и суммирует видеоконтент YouTube, чтобы сохранить ваше время!',
          key: 'Видео',
          title: 'Перевод и резюме видео',
        },
        tab2: {
          desc: 'Нажмите, чтобы перевести изображения при просмотре Интернета.',
          key: 'Изображение',
          title: 'Изображение переводится',
        },
        tab3: {
          desc: 'Мгновенно извлекает ключевую информацию с веб -страниц и предоставляет резюме, повышая эффективность чтения.',
          key: 'Веб -',
          title: 'Интернет -перевод и резюме',
        },
        tag1: 'Простой',
        tag2: 'Эффективный',
        tag3: 'Легко понять',
      },
      title: 'ИИ помощник',
    },
    getStart: 'Начните',
    getStartedForFree: 'Начните бесплатно',
    howItWork: {
      desc: 'ERROR: [Noam integrates AI models to provide users with an intelligent experience for cross-language web page translation and summarization, PDF and image translation, video translation and summarization]',
      title: 'Как это работает',
    },
    lastBlock: { desc: 'Лучший перевод искусственного интеллекта для более плавного опыта чтения' },
    top: {
      desc: 'NOAM - это бесплатное расширение браузера AI, которое помогает вам перевести и суммировать веб -страницы, видео и контент PDF. \\ N присоединяйтесь к NOAM и испытайте магию!',
      title1: 'Одна магия',
      title2: 'Один щелчок',
    },
    userReviews: {
      desc: 'Пятизвездочные обзоры в веб-магазине Chrome',
      title: 'Пользовательские отзывы',
    },
  },
  installTips: {
    btn: 'Попробуйте сейчас',
    text: 'Установите «плагин браузера NOAM», чтобы разблокировать больше функций! Интернет-перекрестное привязки, суммирование веб-видео и многое другое!',
  },
  locale: {
    af: 'африкаанс',
    am: 'Амхарский',
    ar: 'арабский',
    as: 'Ассамский',
    auto: 'Авто обнаружение',
    az: 'Азербайджани',
    ba: 'Башкир',
    bg: 'болгарский',
    bn: 'Бангла',
    bo: 'тибетский',
    bs: 'Боснийский',
    ca: 'Каталонский',
    cs: 'чешский',
    cy: 'валлийский',
    da: 'Датский',
    de: 'немецкий',
    dsb: 'Нижняя сорбиянка',
    dv: 'Дивхи',
    el: 'Греческий',
    en: 'Английский',
    es: 'испанский',
    et: 'эстонский',
    eu: 'Баск',
    fa: 'Персидский',
    fi: 'Финский',
    fil: 'Филиппинец',
    fj: 'Фиджийский',
    fr: 'Французский',
    frCA: 'Французский (Канада)',
    ga: 'Ирландский',
    gl: 'Галиц',
    gom: 'Конкани',
    gu: 'Гуджарати',
    ha: 'Хауса',
    he: 'иврит',
    hi: 'хинди',
    hr: 'хорватский',
    hsb: 'Верхний сорбиян',
    ht: 'Гаитянский креольский',
    hu: 'венгерский',
    hy: 'Армянский',
    id: 'индонезийский',
    ig: 'Игбо',
    ikt: 'Инуиннактун',
    is: 'исландский',
    it: 'Итальянский',
    iu: 'Inuktitut',
    iuLatn: 'Inuktitut (латынь)',
    ja: 'Японский',
    ka: 'Грузинец',
    kk: 'Казах',
    km: 'Кхмер',
    kmr: 'Курдский (север)',
    kn: 'Каннада',
    ko: 'корейский',
    ku: 'Курдский (центральный)',
    ky: 'Кыргиз',
    ln: 'Лингала',
    lo: 'Лаос',
    lt: 'литовский',
    lug: 'Ганда',
    lv: 'Латвиан',
    lzh: 'Китайский (литературный)',
    mai: 'Maithili',
    mg: 'Малагасийский',
    mi: 'Маори',
    mk: 'македонский',
    ml: 'Малаялам',
    mnCyrl: 'Монгольский (Кириллик)',
    mnMong: 'Монгольский (традиционный)',
    mr: 'Маратхи',
    ms: 'малайский',
    mt: 'Мальтийский',
    mww: 'Хмонг Доу',
    my: 'Мьянма (бирманская)',
    nb: 'норвежский',
    ne: 'Непальский',
    nl: 'Голландский',
    noSearchLang: 'Язык не поддерживается',
    nso: 'Sesotho sa leboa',
    nya: 'Няня',
    or: 'Одиа',
    otq: 'Querétaro Otomi',
    pa: 'Пенджаби',
    pl: 'Лак',
    placeholder: 'Поиск',
    prs: 'Дари',
    ps: 'Пушту',
    pt: 'Португальский (Бразилия)',
    ptPT: 'Португальский (Португалия)',
    ro: 'румынский',
    ru: 'Русский',
    run: 'Rundi',
    rw: 'ERROR: [Kinyarwanda]',
    sd: 'Синди',
    si: 'Сингальский',
    sk: 'словацкий',
    sl: 'словенский',
    sm: 'Самоан',
    sn: 'Шона',
    so: 'Сомалийский',
    sq: 'албанский',
    srCyrl: 'Сербский (Кириллик)',
    srLatn: 'Сербский (латынь)',
    st: 'Сезото',
    sv: 'Шведский',
    sw: 'суахили',
    ta: 'Тамильский',
    te: 'телугу',
    th: 'Тайский',
    ti: 'Тигринья',
    tk: 'туркменский',
    tlhLatn: 'Клингон (латынь)',
    tlhPiqd: 'Клингон (Пикад)',
    tn: 'Setswana',
    to: 'Тонганский',
    tr: 'турецкий',
    tt: 'Татар',
    ty: 'Таитянский',
    ug: 'Уйгур',
    uk: 'Украинский',
    ur: 'Урду',
    uz: 'Узбек (латынь)',
    vi: 'вьетнамский',
    xh: 'Xhosa',
    yo: 'Йоруба',
    yua: 'Юкатек Майя',
    yue: 'Кантонский (традиционный)',
    zh: 'китайский',
    zhHans: 'Китайский упрощен',
    zhHant: 'Китайский традиционный',
    zu: 'Зулу',
  },
  login: {
    and: 'и',
    btn: 'Войдите с Google',
    btn1: 'Войдите сейчас',
    desc: 'Войдите, чтобы разблокировать больше опыта',
    policy: 'политика конфиденциальности',
    terms: 'Условия эксплуатации',
    tips: 'Подписавшись, я согласен с',
    title: 'Добро пожаловать в Ноам',
  },
  pageFooter: {
    follow: { facebook: 'Facebook', title: 'Следовать', twitter: 'Twitter' },
    legal: {
      policy: 'политика конфиденциальности',
      terms: 'Условия обслуживания',
      title: 'Юридический',
    },
    product: {
      image: 'Перевод изображения',
      pdf: 'PDF перевод',
      title: 'Продукция',
      video: 'Перевод и резюме видео',
      web: 'Веб -перевод и краткое изложение',
    },
    resources: { title: 'Ресурсы' },
    tools: { title: 'Инструменты', pdf: 'PDF перевод' },
  },
  pageHeader: {
    contact: 'Контакт',
    help: 'Помощь',
    logout: 'Выходите из строя',
    logoutSucc: 'Зарегистрировано.',
    pricing: 'Ценообразование',
    settings: 'Настройки',
    signUp: 'Авторизоваться',
  },
  pdf: {
    autoDetect: 'АВТО DETECTECT',
    cancelBtn: 'Отмена',
    cancelUpload: 'Отмена',
    chatPdf: {
      summaryError: 'Резюме не удалось, попробуйте еще раз позже',
      chatError: 'Чат не удался, попробуйте еще раз позже',
      Search: 'Поиск',
      cancel: 'Отмена',
      chatTitle: 'Добро пожаловать в Ноам! Вот краткое изложение вашего PDF:',
      clear: 'Прозрачный',
      clearContent: 'Это начнет новый разговор. Текущий разговор не будет спасен. Вы уверены?',
      clearDialogTitle: 'Пожалуйста, подтвердите',
      clearSucc: 'Очищен',
      copy: 'Копия',
      copySucc: 'Скопированный',
      delete: 'Удалить',
      deleteCancel: 'Отмена',
      deleteContent: 'Этот PDF не может быть восстановлен после удаления. Вы уверены?',
      deleteOk: 'Удалить',
      deleteSuccess: 'Удален',
      deleteTitle: 'Подтвердить удалить',
      expand: 'Крах',
      historyTitle: 'История',
      listError:
        'Не удалось загрузить список чтения. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
      loading: 'Загрузка ...',
      noDataDesc: 'Никакой истории пока.',
      noMore: 'Нет больше контента.',
      placeholder: 'Спросите что -нибудь об этом PDF',
      summaryTitle: 'Вы можете быть заинтересованы в этих вопросах:',
    },
    collectionEmpty: 'Ваша коллекция пуста.',
    collectionTab: 'Примечания',
    dataLoading: 'Загрузка ...',
    dialogContent: 'Вы уверены, что хотите удалить это?',
    dialogTitle: 'Пожалуйста, подтвердите',
    download: {
      both: 'Двуязычный',
      btn: 'Сохранять',
      cancel:
        'Закрытие этого окна отменит загрузку в формате PDF. Вы уверены, что хотите отменить?',
      desc: 'Сохранить на устройство: загрузка переводов как изображения; Save & Print: загрузка переводов в исходном формате с поддержкой копирования.',
      download: 'Скачать',
      downloadMsg1: 'PDF перевод Прогресс:',
      downloadMsg2: 'Расчетное время осталось:',
      downloadSucc: 'PDF готов! Нажмите, чтобы сохранить.',
      downloadTip: 'Загрузка PDF. Не закрывайте это окно, чтобы избежать ошибок загрузки.',
      error: 'Не удалось сохранить. Попробуйте вместо этого печатать.',
      fileName: 'Имя файла:',
      fileType: 'Тип файла:',
      loading: 'Сохранение ...',
      loading2: 'Загрузка ...',
      minute: 'Протокол ...',
      msg1: 'Некоторые переводы в этом документе длиннее исходного текста, и могут перекрываться в загруженном файле. Мы рекомендуем прочитать на веб -странице.',
      msg2: '1. Перевод еще не завершен. Пожалуйста, скачайте после завершения перевода.',
      msg3: '2. Некоторые переводы слишком длинные. Читайте на веб -странице, чтобы избежать перекрытия текста.',
      msg4: 'Задачи перевода находятся в процессе. Пожалуйста, попробуйте еще раз после их завершения.',
      progress:
        'Перевод PDF. Прогресс: {{Progress}}, Основанное время осталось: {{минуты}} минуты ...',
      save: 'Сохранить на устройство',
      savePrint: 'Сохранить и печатать',
      success: 'Загружен',
      trans: 'Только перевод',
      transContinue: 'Продолжайте переводить',
    },
    downloadBtn: 'Скачать',
    dragTipModal: {
      black: 'космос',
      leftKey: 'левая кнопка',
      ok: 'Понятно',
      press: 'Нажимать',
      tips: 'перетаскивать и просмотреть.',
    },
    entry: 'PDFS',
    fileErrMsg:
      'Чтение файлов не удалось. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
    fileMsg: 'Текущий размер файла:',
    fileMsg2: 'Пожалуйста, загрузите файл меньше 300 МБ.',
    freeBannerBtn: 'Обновление',
    freeBannerTips: 'Бесплатный лимит переводов PDF достигнут',
    guide: {
      placeholder: 'Вставьте ссылку на PDF здесь',
      start: 'Начните переводить',
      text1: 'Двуязычное чтение',
      text2:
        'Прочитайте двуязычие, чтобы сравнить исходный текст и перевод бок о бок, повышая вашу эффективность.',
      text3: 'Общайтесь со своим PDF',
      text4: 'AI-анализ и суммирование. Задайте вопросы о своем PDF и получите мгновенные ответы.',
      text5: 'Точно и эффективно',
      text6: 'AI-двигательный PDF-перевод для большей точности и эффективности.',
      title1: 'Двуязычный перевод',
      title2: 'Общайтесь со своим PDF',
      toast: 'Пожалуйста, введите действительную онлайн -ссылку PDF, заканчивающуюся в .pdf',
    },
    hasTransTask: 'Задача перевода находится в процессе. Пожалуйста, подождите.',
    hoverTrans: 'Парамовые параграфы',
    initial: 'Перевести PDF',
    installText: 'Ваше универсальное решение для повседневных переводов.',
    installText2: 'Сначала установите расширение',
    installTips:
      'Установите расширение для еще большего количества переводов PDF и более плавных переводов веб -сайтов:',
    kw: 'основной продукт',
    link: 'связь',
    listError:
      'Не удалось загрузить PDF. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
    memoTotalCount: '1 пункт всего',
    new: 'новый файл',
    noId: 'Идентификатор файла не найден.',
    notPdf: 'Только файлы PDF.',
    okBtn: 'Удалить',
    okBtn2: 'Понятно',
    original: 'Оригинал',
    parallel: 'Параллель',
    parseErrDialogContent:
      'Эта ссылка PDF не может быть переведена напрямую. Пожалуйста, загрузите PDF и загрузите его для перевода.',
    parseErrTips: 'Не удалось проанализировать файл',
    parseFileToast:
      'Не удалось проанализировать файл. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
    pdfLoading: 'Расположение ...',
    searchPlaceholder: 'Поиск',
    selectTrans: 'Выберите текст, чтобы перевести',
    shareBtn: 'Делиться',
    shareBtnText1: 'Генерировать общую ссылку',
    shareBtnText2: 'Обновите общий контент',
    shareModal: {
      cancel: 'Отмена',
      copy: 'Копия',
      copySucc: 'Ссылка скопирована',
      custom: 'Настраивать:',
      errMsg:
        'Выбранный контент еще не был полностью переведен. Пожалуйста, переведите, прежде чем поделиться.',
      gen: 'Делиться',
      modify: 'Редактировать',
      notSupport: 'Этот язык в настоящее время не поддерживается.',
      page: 'Страницы',
      pageNuErr: 'Пожалуйста, введите действительный номер страницы.',
      range: 'Объем:',
      remain: 'оставшийся',
      remain1: 'Общее предполагаемое время:',
      search: 'Поиск',
      settings: 'Настройки обмена:',
      shareSetting: 'Поделиться настройками',
      shareText: 'Делиться',
      shareTips: 'Поделитесь переведенной ссылкой PDF с друзьями:',
      sourceLang: 'От:',
      target: 'К:',
      text1: 'Поделиться настройками',
      text2: 'Генерировать общую ссылку',
      totalPage: '1 страница всего',
      trans: 'Переводить',
      translateTips:
        'Совет: если перевод занимает некоторое время, вы можете закрыть это окно и поделиться позже.',
      translating: 'Перевод PDF ...',
      update: 'Обновить ссылку «Поделиться»',
    },
    shareMsg1: 'Поделиться сгенерированной ссылкой.',
    shareMsg2: 'Общий контент обновлен.',
    shareMsg3:
      'Не удалось генерировать общую ссылку. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
    shareMsg4:
      'Не удалось обновить общий контент. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
    shareTips: 'ERROR: [Your PDF translation is ready! Share it with your friends.]',
    start: 'Начните бесплатную пробную версию',
    thumbnail: 'Оглавление',
    toast1: 'Загрузка PDF. Пожалуйста, попробуйте еще раз позже.',
    toast2: 'Содержание PDF слишком велик. Диалог в настоящее время не поддерживается.',
    toast3: 'Загрузка. Пожалуйста, попробуйте еще раз после того, как загрузка закончена.',
    toolbar: { Adjust: 'Регулировать', autoFit: 'Автозаголка' },
    trans: 'Перевод',
    transSucc: 'Перевод успешный!',
    unLoginToast: 'Пожалуйста, войдите в систему, чтобы использовать эту функцию.',
    uploadBtn: 'Загрузить',
    uploadErr:
      'Загрузка файла не удалась. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
    uploadErrSignUrl:
      'Не удалось получить URL загрузки. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
    uploadMsg1: 'Перетащите свой файл здесь.',
    uploadMsg2: 'Поддерживаемые типы файлов: PDF |  Максимальный размер файла: 300 МБ',
    uploadMsg3: 'Нажмите, чтобы выбрать или перетащить файлы здесь.',
    uploading: 'Загрузка',
    uploadingMsg: 'Загрузка. Пожалуйста, подождите.',
    uploadingMsg1: 'Файл загружается. Пожалуйста, попробуйте еще раз позже.',
    uploadingMsg2: 'Файл в настоящее время преобразуется. Пожалуйста, попробуйте еще раз позже.',
    uploadingMsg3:
      'Запрос на прогресс преобразования не удался. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
    uploadingMsg4:
      'Ноам не может получить доступ к локальным файлам. Пожалуйста, вручную загрузите PDF для перевода.',
    uploadingMsg5:
      'Не удалось получить URL -адрес файла. Пожалуйста, попробуйте еще раз позже или свяжитесь с поддержкой.',
    video: 'видео',
    vipBannerBtn: 'Обновление',
    vipBannerTips: 'Вы достигли предела перевода в PDF за этот месяц.',
    webTrans: 'Полная перекрестная ссылка',
  },
  pricing: {
    FAQ: 'Часто задаваемые вопросы',
    FQAObj: {
      a1: 'Да, NOAM предлагает бесплатный план, который вы можете использовать сразу.',
      a2: 'Мы предлагаем три плана членства: Pro, Pro+и Enterprise. Вы можете платить ежемесячно или ежегодно. Ежегодный биллинг предлагает значительную экономию.',
      a3: 'Все функции доступны на обоих планах. Основное отличие - стоимость: годовые подписки стоят меньше в целом. Ежемесячные подписки выставляются счета каждый месяц, в то время как годовые планы выставляются один раз в год.',
      a4: 'Вы можете отменить свою подписку в любое время в настройках учетной записи.',
      q1: 'Есть бесплатный план?',
      q2: 'Какие ценовые планы и варианты оплаты доступны?',
      q3: 'В чем разница между подпиской ежемесячно и ежегодно?',
      q4: 'Как отменить подписку?',
    },
    around: 'Вокруг',
    billedMonthly: 'Выставляется ежемесячно',
    billedYearly: 'Выставляется ежегодно',
    day: 'день',
    desc: 'Сравните планы и выберите лучшее',
    detailedCompare: 'Сравните планы',
    discount: 'Скидка 20%',
    enterprise: {
      benefit1: 'Приоритетная поддержка клиентов',
      benefit2: 'Несколько пользователей',
      benefit3: 'Аптированные решения',
      benefit5: 'Выделенный менеджер по учетной записи',
      btn: 'Связаться с нами',
      recommendText: 'Пользовательские планы (≥3 人)',
      talkToUs: 'Свяжитесь с нами',
    },
    free: {
      benefit1: 'Мгновенный перевод 100 раз в день',
      benefit2: 'Перевод и сводка веб -сайта',
      benefit3: '30 переводов изображений',
      benefit4: 'Перевод и резюме видео',
      benefit5: '10 переводов в формате PDF',
      benefit6: '5000 жетонов',
      btn: 'Попробуйте бесплатно',
      recommendText: 'Бесплатная пробная версия',
    },
    imageTranslation: 'Перевод изображения',
    month: 'месяц',
    monthly: 'Ежемесячно',
    pageTitle: 'Ценообразование',
    pdf: {
      chat: 'PDF -чат запросы',
      maxPage: 'Максимум Страницы за PDF',
      translation: 'PDF перевод',
    },
    preMonth: 'Помесячно',
    pro: {
      benefit1: 'Приоритетная поддержка клиентов',
      benefit2: '1 000 000 жетонов/месяц',
      benefit3: 'Перевод и сводка веб -сайта',
      benefit4: '200 переводов изображений',
      benefit5: 'Перевод и резюме видео',
      benefit6: '200 переводов PDF',
      btn: 'Начните',
      recommendText: 'Самый популярный',
    },
    proPlus: {
      benefit1: 'Приоритетная поддержка клиентов',
      benefit2: '3 000 000 жетонов/месяц',
      benefit3: 'Перевод и сводка веб -сайта',
      benefit4: '500 переводов изображений',
      benefit5: 'Перевод и резюме видео',
      benefit6: '500 PDF переводов',
      recommendText: 'Лучшее значение',
    },
    video: { summary: 'Видео -краткое изложение', translation: 'Видео перевод' },
    web: {
      contrastiveTranslation: 'Двуязычный перевод',
      dictionaryTranslation: 'Перевод отбора',
      hoverTranslation: 'Перевод Hover',
      instantTranslation: 'Мгновенный перевод',
      summary: 'Краткое изложение веб -страницы',
    },
    yearly: 'Ежегодно',
  },
  privacy: {
    block1:
      'Ноам («Ноам», «Мы», «Наш» или «нас») уважает вашу конфиденциальность и стремится защищать любую информацию, которую мы получаем от вас или о вас. Настоящая Политика конфиденциальности описывает нашу практику в отношении сбора или использования личной информации из использования нашего веб -сайта, приложений и услуг (в совокупности «Услуги»). Настоящая политика конфиденциальности не относится к контенту, с которым мы обрабатываем от имени наших клиентов бизнес -продукта, например, наш API. Использование этих данных подлежит нашему соглашению о клиентах, которое охватывает доступ и использование этих продуктов.',
    block10:
      'Мы внедряем коммерчески разумные технические, административные и организационные меры для защиты онлайн и офлайн личной информации от потери, неправильного использования и несанкционированного доступа, раскрытия, изменения или враждебных действий. Однако ни одна передача в Интернет или электронную почту не может гарантировать полную безопасность или точность. В частности, электронные письма, отправленные нам или от нас, могут не быть в безопасности. Таким образом, вы должны быть особенно осторожны при принятии решения о том, какую информацию отправить нам через Сервис или электронную почту. Кроме того, мы не несем ответственности за какую -либо препятствие настройках конфиденциальности или меры безопасности в Сервисе или настройках безопасности сторонних веб -сайтов или меры безопасности. Мы будем сохранять вашу личную информацию столько, сколько необходимо для нас, чтобы предоставить вам услуги или для других законных деловых целей, таких как разрешение споров, соображения безопасности и безопасности или соблюдение наших юридических обязательств. Продолжительное время, которое мы сохраняем, будет зависеть от многих факторов, таких как количество, природа, чувствительность информации, потенциальные риски несанкционированного использования или раскрытия, целей, для которых мы обрабатываем информацию, и другие юридически обязательные соображения.',
    block11:
      'Мы можем время от времени обновлять эту политику конфиденциальности. Когда мы это сделаем, мы опубликуем обновленную версию на этой странице, если иное не требуется применимого закона.',
    block12:
      'Если у вас есть какие -либо вопросы без ответа или опасения по поводу этой политики конфиденциальности, пожалуйста, свяжитесь с нашим обслуживанием клиентов. Электронная почта:',
    block2: 'Мы собираем следующую личную информацию («Личную информацию»), связанную с вами:',
    block3:
      'Информация, предоставленная вами: когда вы создаете учетную запись для использования наших услуг или общения с нами, мы собираем личную информацию следующим образом:',
    block4:
      'Личная информация, автоматически полученная от использования услуг: когда вы получаете доступ, используете или взаимодействуете с службами, мы получаем следующую информацию о вашем доступе, использовании или взаимодействии («Техническая информация»):',
    block5: 'Мы можем использовать личную информацию для следующих целей:',
    block6:
      'Сводная информация или де-идентифицированная информация: мы можем агрегировать или де-идентифицировать личную информацию, чтобы предотвратить ее повторное использование в целях идентификации и использовать такую ​​информацию для анализа эффективности наших услуг, улучшения и добавления функций в наши услуги, проведение исследований и для аналогичных целей. Кроме того, мы можем проанализировать общее поведение и характеристики наших пользователей услуг и обмениваться агрегированной информацией с третьими лицами, публиковать такую ​​агрегированную информацию или сделать ее в целом доступным. Мы можем собирать агрегированную информацию через услуги, через файлы cookie и другие средства, описанные в настоящей Политике конфиденциальности. Мы будем поддерживать и использовать отделенную информацию в анонимной или де-идентифицированной форме, и мы не будем пытаться повторно идентифицировать такую ​​информацию, если это не требуется в соответствии с законом.',
    block7:
      'В некоторых случаях мы можем предоставить вашу личную информацию третьим сторонам без дальнейшего уведомления, если не требуется по закону:',
    block8:
      'В зависимости от вашего географического положения, люди в Европейском экономическом районе, Великобритании и во всем мире могут иметь определенные законом права относительно их личной информации. Например, вы можете иметь право:',
    block9:
      'Служба может содержать ссылки на другие веб -сайты, не управляемые или не контролируемые NOAM, включая услуги социальных сетей («Сторонние веб -сайты»). Информация, которую вы делитесь с сторонними веб -сайтами, будет регулироваться конкретными политиками конфиденциальности и условиями обслуживания веб -сайтов сторонних сторон, а не в настоящей Политике конфиденциальности. Мы предоставляем эти ссылки для удобства и не подразумеваем наше одобрение или обзор этих веб -сайтов. Пожалуйста, свяжитесь с сторонними веб -сайтами непосредственно для получения информации о их политике и условиях конфиденциальности.',
    subBlock1:
      'Информация об учетной записи: Когда вы создаете учетную запись на нашей платформе, мы собираем информацию, связанную с вашей учетной записью, включая ваше имя, контактную информацию, учетные данные, информацию о платежной карте и историю транзакций («Информация об учетной записи»).',
    subBlock10: 'Предоставление, управление, поддержание и/или анализ услуг;',
    subBlock11: 'Общаться с вами;',
    subBlock12: 'Разработка новых продуктов и услуг;',
    subBlock13:
      'Предотвращение мошенничества, преступной деятельности или неправильного использования наших услуг и защита безопасности наших ИТ -систем, архитектуры и сетей;',
    subBlock14: 'Проведение бизнес -переводов;',
    subBlock15:
      'Соблюдение юридических обязательств и судебных разбирательств, защита наших прав, конфиденциальности, безопасности или имущества, а также с нашими филиалами, вы или другими третьими лицами.',
    subBlock16:
      'Поставщики и поставщики услуг: чтобы помочь нам в удовлетворении операционных потребностей в бизнесе и выполнении определенных услуг и функций, мы можем предоставить личную информацию поставщикам и поставщикам услуг, включая поставщиков хостинга, поставщиков облачных услуг и других поставщиков услуг по информационным технологиям, программное обеспечение для связи по электронной почте и поставщики услуг веб -аналитики и т. Д.',
    subBlock17:
      'Бизнес -трансфер: если мы участвуем в стратегических транзакциях, реорганизации, банкротствах, поглощениях банкротства или переходе на услуги к другому поставщику (совместно, «транзакциям»), ваша личная информация и другая информация могут быть переданы с аналогами транзакций и другими сторонами, помогающими в транзакциях во время должной осмотрительности и передачи в качестве части транзакций с другими активами в успешную или аффилированную компанию.',
    subBlock18:
      'Требования к юридическим вопросам: мы можем поделиться вашей личной информацией с государственными органами власти, сверстниками промышленности или другими третьими лицами, включая вашу информацию о взаимодействии с нашими услугами, (1), если это требуется в соответствии с законом или если мы считаем, что такие действия необходимы для выполнения юридических обязательств; (2) защищать и защищать наши права или имущество; (3) если мы в одностороннем порядке определим, что существует нарушение наших условий, политики или законов; (4) обнаружить или предотвратить мошенничество или другие незаконные действия; (5) для защиты наших продуктов, сотрудников или пользователей, или общественной безопасности, безопасности, целостности; или (vi) защищать от юридической ответственности.',
    subBlock19:
      'Получите доступ к вашей личной информации и информации о том, как она обрабатывается.',
    subBlock2:
      'Пользовательский контент: Когда вы используете наши услуги, мы собираем личную информацию из ваших входов, загрузки файлов или предоставленные нам отзывы («Контент»).',
    subBlock20: 'Запросите удаление вашей личной информации из наших записей.',
    subBlock21: 'Исправить или обновить свою личную информацию.',
    subBlock22: 'Передайте свою личную информацию третьей стороне (переносимость данных).',
    subBlock23: 'Ограничьте, как мы обрабатываем вашу личную информацию.',
    subBlock24:
      'Отмените свое согласие - где мы полагаемся на согласие в качестве правовой основы для обработки, вы можете снять свое согласие в любое время.',
    subBlock25: 'Возражайте против того, как мы обрабатываем вашу личную информацию.',
    subBlock26: 'Улучшение наших услуг и проведение исследований;',
    subBlock3:
      'Информация об общении: если вы отправите нам сообщения, мы будем собирать ваше имя, контактную информацию и содержание ваших сообщений («Информация об общении»).',
    subBlock4:
      'Информация о социальных сетях: у нас есть страницы на веб -сайтах в социальных сетях, таких как Instagram, Facebook, Medium, Twitter, YouTube и LinkedIn. Когда вы взаимодействуете с нашими страницами в социальных сетях, мы собираем личную информацию, которую вы решите предоставить нам, такую ​​как ваши контактные данные («социальная информация»). Кроме того, компании, размещающие наши страницы в социальных сетях, могут предоставить нам агрегированную информацию и анализ нашей деятельности в социальных сетях.',
    subBlock5:
      'Данные журнала: Информация автоматически отправлена ​​вашим браузером при использовании наших услуг. Данные журнала включают адрес вашего интернет -протокола (IP), тип и настройки браузера, дату и время ваших запросов, а также то, как вы взаимодействуете с нашим веб -сайтом.',
    subBlock6:
      'Данные об использовании: мы можем автоматически собирать информацию о вашем использовании Сервиса, такой как типы контента, с которым вы просматриваете или взаимодействуете, о функциях, которые вы используете, о действиях, которые вы принимаете, а также ваш часовой пояс, страну, дату и время доступа, пользовательский агент и версию, компьютерный или тип мобильного устройства и ваше компьютерное подключение.',
    subBlock7:
      'Информация о устройстве: это включает в себя имя устройства, операционную систему, идентификатор устройства и используемый вами браузер. Собранная информация может зависеть от типа устройства, которое вы используете, и его настройки.',
    subBlock8:
      'Куки: мы используем файлы cookie для работы и управления нашими услугами и улучшения вашего опыта. «Cookie» - это информация, отправленная веб -сайтом, который вы посещаете в свой браузер. Вы можете настроить свой браузер, чтобы принять все файлы cookie, отклонить все файлы cookie или уведомить вас, когда предоставляется файл cookie, чтобы вы могли решить, принимать ли его каждый раз. Однако отказ от файлов cookie может помешать вам использовать или негативно повлиять на дисплей или функциональность определенных областей или функций веб -сайта. Для получения дополнительной информации о файлах cookie, пожалуйста, посетите все о файлах cookie.',
    subBlock9:
      'Аналитика: мы можем использовать различные продукты онлайн -аналитики, которые используют файлы cookie, чтобы помочь нам анализировать, как пользователи используют наши услуги, и улучшить ваш опыт при использовании услуг.',
    subTitle1: 'Личная информация, которую мы собираем',
    subTitle2: 'Как мы используем личную информацию',
    subTitle3: 'Раскрытие личной информации',
    subTitle4: 'Ваши права',
    subTitle5: 'Ссылки на другие сайты',
    subTitle6: 'Безопасность и сохранение информации',
    subTitle7: 'Модификация политики конфиденциальности',
    subTitle8: 'Как связаться с нами',
    title: 'политика конфиденциальности',
    updateTime: 'Обновлено: 15 марта 2024 г.',
  },
  privacyCollectionPanel: {
    acceptBtn: 'Принять все',
    text: 'Чтобы улучшить ваш опыт, мы используем файлы cookie для персонализации контента и услуг.',
    title: 'В этом сайте используются файлы cookie',
  },
  slogen: 'Самый простой помощник ИИ',
  stripe: {
    contact: 'Свяжитесь с нами по адресу contact@noam.tools с любыми вопросами!',
    fail: {
      btn: 'Повторно',
      text1: 'Мы не могли обработать ваш платеж.',
      text2: 'Проверьте свое соединение и попробуйте еще раз.',
      title: 'Оплата не удалась',
    },
    succ: {
      btn: 'Пойдем',
      text1: 'Добро пожаловать в Ноам,',
      text2: 'Начнем!',
      title: 'Поздравляю',
    },
  },
  terms: {
    block1: 'Спасибо, что использовали NOAM!',
    block10:
      '(а) Плата и выставление счетов. Вы будете платить все сборы («сборы») в соответствии с ценообразованием и условиями на соответствующей странице ценообразования или как согласовано в письменной форме между нами. Мы оставляем за собой право исправлять ошибки или ошибки ценообразования, даже если мы выпустили счета или получили оплату. Вы предоставите полную и точную информацию о выставлении счетов, включая действительный и авторизованный способ оплаты. Мы будем взимать с вашего метода оплаты на периодической основе, как это было согласовано, но мы можем разумно изменить дату выставления счетов. Вы разрешаете NOAM, его филиалов и сторонних платежных процессоров взимать платеж. Если ваш платеж не удастся, мы предоставим вам письменное уведомление и можем приостановить доступ к услуге до получения оплаты. За исключением случаев, указанных в настоящем Соглашении, платежи не подлежат возврату.',
    block11:
      '(б) налоги. Если не указано иное, сборы не включают какие -либо федеральные, государственные, местные и иностранные налоги, пошлины и аналогичные оценки («налоги»). Вы несете ответственность за все налоги, связанные с вашими покупками, за исключением налогов в зависимости от нашего чистого дохода, за который мы выставляем выставление с вами. Вы соглашаетесь незамедлительно платить такие налоги и предоставить нам юридически действительные заявления о конфиденциальности и получать необходимые согласия для обработки таких данных, и вы гарантируете нам, что вы обрабатываете такие данные в соответствии с применимым законодательством.',
    block12:
      '(в) Изменения цен. Мы можем изменить наши цены, уведомив вас через вашу учетную запись и/или наш веб -сайт. Повышение цены вступит в силу сразу после публикации. Любые изменения цен будут применяться к сбору за ваш счет после даты вступления в силу изменения.',
    block13:
      '(г) споры и просроченные платежи. Если вы хотите оспорить какие -либо сборы или налоги, пожалуйста, свяжитесь с contact@noam.tools в течение тридцати (30) дней с даты счета.',
    block14:
      '(д) бесплатное использование. Вы не можете создавать несколько учетных записей для получения бесплатных кредитов. Если мы определим, что вы не используете бесплатные кредиты добросовестно, мы можем взимать вам стандартные сборы или прекратить предоставлять доступ к услуге.',
    block15:
      '(а) Конфиденциальность. У вас может быть доступ к конфиденциальной информации Ноама. Вы можете использовать конфиденциальную информацию, разрешенную в соответствии с настоящими Условиями с целью использования Сервиса. Вы не можете раскрывать конфиденциальную информацию ни одной третьей стороне, и вы будете защищать конфиденциальную информацию не менее защитной, чем защищаете свою аналогичную конфиденциальную информацию, по крайней мере, с разумной заботой. Конфиденциальная информация-это непубличная информация, обозначенная как конфиденциальная NOAM, или которая должна рассматриваться как конфиденциальная в этих обстоятельствах, включая программное обеспечение, спецификации и другую непубличную бизнес-информацию. Конфиденциальная информация не включает информацию, которая: (1) в целом становится доступной для общественности без вины с вашей стороны; (2) вы имели в своем распоряжении без каких -либо обязательств по конфиденциальности, прежде чем получить его в соответствии с настоящими Условиями; (3) законно раскрывается вам третьей стороной без каких -либо обязательств по конфиденциальности; или (4) независимо развивается вами без использования конфиденциальной информации. Вы можете раскрыть конфиденциальную информацию, если это требуется в соответствии с законом, судом или другим государственным приказом, но вы должны предоставить предварительно письменное уведомление NOAM разумным образом и, насколько это возможно, приложить разумные усилия по ограничению объема раскрытия, включая оказание помощи нам в противоположных запросах на раскрытие информации.',
    block16:
      '(б) безопасность. Вы должны внедрить разумные и соответствующие меры, чтобы помочь защитить ваш доступ и использование Сервиса. Если вы обнаружите какие -либо уязвимости или нарушения, связанные с использованием вами Сервиса, вы должны незамедлительно связаться с NOAM и предоставить подробную информацию об уязвимости или нарушениях.',
    block17:
      '(c) Обработка персональных данных. Если вы используете Сервис для обработки персональных данных, вы должны предоставить юридически достаточные заявления о конфиденциальности и получить необходимые согласия для обработки таких данных, и вы гарантируете нам, что вы обрабатываете такие данные в соответствии с применимым законодательством.',
    block18:
      '(а) прекращение; Приостановка. Эти термины будут эффективными от первого использования услуг и останутся в силе до завершения. Вы можете прекратить эти условия в любое время по любой причине, прекратив использование Сервиса и контента. Мы можем прекратить эти условия с предварительным уведомлением по любой причине. Мы можем немедленно прекратить эти термины, уведомив вас, если вы существенно нарушите раздел 2 (требования об использовании), раздел 5 (конфиденциальность, безопасность и защита данных), раздел 8 (разрешение споров) или раздел 9 (общие условия), или если наши отношения с любым поставщиком сторонних технологий за пределами наших изменений контроля или соблюдение законов или правительственных запросов. Мы можем приостановить ваш доступ к Сервису, если вы не выполните эти условия, или если ваше использование представляет для нас риск безопасности для нас или какой -либо третьей стороны, или если мы подозреваем, что ваше использование мошеннирует или может подвергнуть нас или какую -либо третью сторону ответственности.',
    block19:
      '(б) Влияние прекращения. После прекращения вы перестанете использовать Сервис и быстро вернуть или уничтожить любую конфиденциальную информацию, как указано нами. Положения настоящих Условий, которые по их природе должны выжить в увольнении или истечении срока действия, включая, помимо прочего, разделы 3 и 5-9, должны выжить.',
    block2:
      'Настоящие Условия использования применяются к использованию вами услуг NOAM, включая наши интерфейсы программного программирования, программное обеспечение, инструменты, услуги разработчиков, данные, документацию и веб -сайт (в совокупности «Сервисы»). Используя наши услуги, вы соглашаетесь соблюдать эти условия. Наша политика конфиденциальности объясняет, как мы собираем и используем личную информацию.',
    block20:
      '(а) компенсация. Вы будете защищать, возмещать и удерживать нас, наших филиалов и нашего персонала, безвредного от любых претензий, убытков и расходов (включая гонорары адвокатов), возникающие из -за использования услуг или связанных с вами, включая ваше содержание, использование вами продуктов или услуг, связанных с Сервисом, и вашего нарушения настоящих условий или применимого закона.',
    block21:
      '(б) Отказ от ответственности. Услуга предоставляется «как есть». В той мере, в которой разрешены законы, мы и наши филиалы и лицензиары не делаем никаких представлений или гарантий в отношении услуг и не даем никаких гарантий, включая, помимо прочего, гарантии торговой точки зрения, пригодность для определенной цели, удовлетворительное качество, не внесение инфляции и тихое удовольствие и любые гарантии, вытекающие из сделки или использования торговли. Мы не гарантируем, что служба будет непрерывной, точной или без ошибок, или что любой контент будет безопасным, не потерянным или не измененным.',
    block22:
      '(в) ограничение ответственности. Ни мы, наши филиалы, ни наши лицензиары не несут ответственности за любые косвенные, случайные, особые, косвенные или штрафные убытки, включая потерю прибыли, потерю репутации, потерю использования, потерю данных или другие нематериальные убытки, даже если нам сообщили о возможности такого ущерба. В соответствии с настоящими Условиями наша общая ответственность не будет превышать сборы, которые вы заплатили услугу в течение двенадцати (12) месяцев, предшествующих претензии или сто долларов США (100 долларов США), в зависимости от того, что больше. Ограничения в этом разделе применяются в максимальной степени, разрешенной применимым законодательством.',
    block23:
      'Условия и использование вами услуг регулируются законами Соединенных Штатов, за исключением правил конфликта законов США. Использование заявки также может быть подлежит другим местным, государственным, национальным или международным законам. Любые судебные иски или судебное разбирательство, связанное с настоящими Условиями, будут представлены исключительно в судах Соединенных Штатов, и вы соглашаетесь подчиняться личной юрисдикции таких судов.',
    block24:
      '(а) Отношения сторон. Ноам и вы являетесь независимыми подрядчиками, и ни одна из сторон не имеет права представлять или связывать другую сторону или брать на себя обязательства перед другой стороной без предварительного письменного согласия другой стороны.',
    block25:
      '(б) Использование бренда. Вы не можете использовать имя, логотипы или товарные знаки NOAM или каких -либо его филиалов без нашего предварительного письменного согласия.',
    block26:
      'Если какое -либо положение настоящих Условий будет определена как недействительное, незаконное или невыполнимое, оставшиеся положения останутся в полной силе и эффекте.',
    block3:
      'Если вам моложе 18 лет, вы должны получить разрешение от ваших родителей или законных опекунов на использование этой службы. Если вы используете Сервис от имени другого лица или субъекта, вам должно быть уполномочено принимать эти условия от их имени. Вы должны предоставить точную и полную информацию для регистрации для учетной записи. Вы можете не предоставлять свои учетные данные или учетную запись кому -либо за пределами вашей организации, и вы несете ответственность за все действия, проводимые с использованием ваших учетных данных.',
    block4:
      '(а) Использование обслуживания. Вы можете получить доступ к Сервису в соответствии с настоящими Условиями, и мы предоставляем вам неисключительное право на использование Сервиса. При использовании Сервиса вы будете соблюдать настоящие Условия и все применимые законы. Мы и наши филиалы владеем всеми правами, названиями и интересами в службе.',
    block5:
      '(б) обратная связь. Мы приветствуем обратную связь, комментарии, идеи, предложения и улучшения. Если вы предоставляете какой -либо такой контент, мы можем использовать его без каких -либо ограничений и без компенсации для вас.',
    block6:
      '(в) Ограничения. Вы не можете: (1) использовать сервис таким образом, чтобы нарушать, незаконно присваиваются или нарушают любые права других; (2) обратный инженер, декомпиляция, разборка, перевод или иным образом пытаться обнаружить исходный код или основные компоненты моделей обслуживания, алгоритмов и систем (если такие ограничения не запрещены применимым законом); (3) использовать вывод услуги для разработки моделей, конкурирующих с NOAM; (4) извлечь данные или вывода из службы, используя любые методы автоматизированного или программирования, если это не разрешено через API, включая соскабливание, веб -сбора или извлечение веб -данных; (5) представляют вывод услуги как искусственно генерируемый, когда это не является, или иным образом нарушает нашу политику использования; (6) покупать, продавать или передавать ключи API без нашего предварительного согласия; или (7) предоставить нам любую личную информацию о детях в возрасте до 13 лет или применимого возраста цифрового согласия. Вы будете соблюдать любые ограничения по ставке и другие требования в нашей документации.',
    block7:
      '(d) Сторонние услуги. Любое стороннее программное обеспечение, услуги или другие продукты, связанные с обслуживанием, регулируются их собственными условиями, и мы не несем ответственности за сторонние продукты.',
    block8:
      '(а) Ваш контент. Вы можете предоставить вход («вход») для Сервиса и получения вывода («вывод»), сгенерированного и возвращаемого на основе ввода (в совокупности, называемом «содержанием»). Между сторонами и в той степени, разрешенной применимым законодательством, у вас есть все вклад. NOAM может использовать контент для предоставления и поддержания услуг, соблюдать применимые законы и обеспечить соблюдение нашей политики. Вы несете ответственность за содержание, в том числе гарантировать, что он не нарушает какие -либо применимые законы или эти условия.',
    block9:
      '(б) Точность. Искусственный интеллект и машинное обучение быстро развивающиеся области исследований. Мы постоянно стремимся улучшить наш сервис, чтобы сделать его более точным, надежным, безопасным и полезным. Учитывая вероятностный характер машинного обучения, использование нашего сервиса может привести к неправильным результатам в определенных случаях, что может не отражать реальных людей, мест или фактов. Вы должны надлежащим образом оценить точность любого вывода на основе вашего варианта использования, в том числе путем вручную просмотреть выходы.',
    subTitle1: 'Регистрация и доступ',
    subTitle10: 'Разделительность',
    subTitle2: 'Требования к использованию',
    subTitle3: 'Содержание',
    subTitle4: 'Сборы и оплата',
    subTitle5: 'Конфиденциальность, безопасность и защита данных',
    subTitle6: 'Термин и прекращение',
    subTitle7: 'Компенсация; Отказ от ответственности; Ограничение ответственности',
    subTitle8: 'Управляющий законодательство и юрисдикция',
    subTitle9: 'Общие термины',
    title: 'Условия обслуживания',
    updateTime: 'Обновлено: 15 марта 2024 г.',
  },
  trialModal: {
    btn: 'Начните сейчас (всего $ 0,99)',
    chat: 'Chatpdf',
    desc1:
      'После судебного разбирательства вам будет взиматься годовая плата в размере 180 долларов США.',
    desc2: 'Отменить в любое время',
    focus: 'Фокусировка',
    hover: 'Перевод Hover',
    image: 'Перевод изображения',
    installBtn: 'Установите сейчас, чтобы получить свой подарок',
    memo: 'Фавориты управления',
    pdf: 'PDF Параллельный перевод',
    realtime: 'Мгновенный перевод',
    select: 'Перевод выбора слов',
    title: 'Добро пожаловать подарок',
    trialText: '7-дневное испытание',
    video: 'Видео перевод',
    videoSummary: 'Видео -краткое изложение',
    web: 'Параллельный перевод',
    webSummary: 'Сводная информация',
  },
  upgradeModal: {
    btn: 'Обновите сейчас',
    chat: { free: 'Вы достигли предела ChatPDF', pro: 'Вы достигли лимита ChatPDF за этот месяц' },
    contactStr:
      'Пожалуйста, дождитесь следующего сброса или свяжитесь с нами по адресу contact@noam.tools.',
    limitAlertStr: 'Вы достигли свободного ограничения плана. Обновите, чтобы продолжить.',
    more: 'Просмотреть планы',
    pageLimit: { free: 'Вы достигли предела страницы PDF' },
    title: 'Напоминание',
    upgradeAlertStr: 'Вы достигли свободного ограничения плана. Обновите, чтобы продолжить.',
    upload: {
      free: 'Вы достигли предела перевода в PDF',
      pro: 'Вы достигли предела перевода в PDF за этот месяц',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'Присоединяйтесь сейчас',
      label: 'Новые преимущества пользователя:',
      remain: 'Только 30 осталось',
      text: 'Доступны всего 100 мест! Возьми свой сейчас!',
    },
  },
  aiPdfTranslator: {
    title: 'Бесплатный AI PDF переводчик: Переводите PDF и сравнивайте тексты на любом языке',
    desc: 'Легко переводите PDF-файлы на любые языки с помощью искусственного интеллекта. Сравнивайте оригинальный и переведённый текст бок о бок — быстро и бесплатно.',
    keywords: 'GPT-4, AI-ассистент, Перевод, Резюме, Фокус, ChatPDF, Заметка, Эффективность',
    sourceToTarget: {
      title:
        'Бесплатный инструмент для перевода PDF: переводите с {{source}} на {{target}} бесплатно',
      desc: 'Переводите свои PDF-файлы с любого исходного языка на предпочитаемый вами язык бесплатно. Быстрый, точный и безопасный перевод PDF с использованием передовых технологий искусственного интеллекта.',
    },
    headerIntroduce: {
      title: 'Noam: Больше, чем просто онлайн-перевод',
      introduce1: {
        title: 'Noam · PDF-читалка',
        desc: '✨Боковой перевод + AI Q&A. Быстро и точно переводите PDF на нужный вам язык. Свободно задавайте вопросы по содержанию, чтобы лучше понимать свои PDF-файлы.',
      },
      introduce2: {
        title: 'Noam · Расширение для бокового перевода',
        desc: '👏Решите все свои задачи по переводу веб-страниц:',
        detail1: { title: 'Перевод веб-страниц: ', desc: 'Двуязычный просмотр бок о бок.' },
        detail2: { title: 'Перевод слов: ', desc: 'Быстрый перевод в один клик.' },
        detail3: {
          title: 'Мгновенный перевод: ',
          desc: 'Переводите слова или предложения мгновенно.',
        },
        detail4: { title: 'Перевод изображений: ', desc: 'Заменяйте изображения на переведённые.' },
        detail5: { title: 'Перевод видео: ', desc: 'Двуязычные субтитры для лучшего просмотра.' },
        footer:
          'Испытайте больше функций для чтения на базе искусственного интеллекта — для ещё более умного перевода!',
      },
    },
    subtitle: 'Переводите PDF онлайн бесплатно',
    introduce: {
      module1: {
        detail1: {
          title: 'Мгновенный боковой перевод PDF',
          desc1:
            'Мгновенно отображайте оригинальный и переведённый текст в синхронизированном боковом режиме',
          desc2: 'Легко сравнивайте обе версии с помощью синхронизированной прокрутки',
          desc3: 'Сохраняйте одинаковое форматирование для комфортного чтения',
        },
        detail2: {
          title: 'Точное выравнивание и проверка контента',
          desc1: 'Идеальное выравнивание исходного и переведённого текста для удобной проверки',
          desc2: 'Каждый фрагмент текста точно совпадает в обеих версиях',
          desc3: 'Быстро находите и исправляйте несоответствия для надёжных результатов',
        },
      },
      module2: {
        detail1: {
          title: 'Несколько продвинутых AI-моделей для точного перевода',
          desc1: 'Выбирайте среди лучших AI-моделей для своих нужд',
          desc2: 'Гарантируйте наилучшие результаты для различных типов документов и отраслей',
          desc3: 'Гибкие варианты моделей обеспечивают индивидуальные решения для каждой ситуации',
        },
        detail2: {
          title: 'Передовой AI-перевод для любого типа контента',
          desc1: 'Наш мощный AI гарантирует высокую точность и естественное понимание языка',
          desc2: 'Легко справляется с техническими, научными и творческими документами',
          desc3: 'Обеспечивает надёжный результат для любых ваших потребностей в переводе',
          desc4:
            'Интеллектуально адаптируется к разным видам контента для максимальной эффективности',
        },
      },
      module3: {
        detail1: {
          title: 'Интеллектуальное взаимодействие с документами',
          desc1: 'Легко общайтесь с вашими PDF и презентациями с помощью продвинутого AI',
          desc2: 'Мгновенно задавайте вопросы по содержанию и получайте точные ответы',
          desc3: 'Быстро создавайте краткие резюме для больших документов',
        },
        detail2: {
          title: 'Глубокий анализ и бесшовная интеграция',
          desc1: 'Извлекайте ключевую информацию и анализируйте сложные данные с помощью AI',
          desc2: 'Получайте ценные знания о технических, научных или творческих материалах',
          desc3:
            'Бесшовно интегрируется с нашим PDF переводчиком для полного управления документами',
        },
      },
      module4: {
        detail1: {
          title: 'Больше, чем перевод PDF: всё-в-одном для перевода веб-страниц',
          desc: 'Откройте для себя наше мощное расширение для бокового перевода, разработанное для любых онлайн-сценариев чтения.',
          desc1:
            'Перевод веб-страниц: наслаждайтесь двуязычным контентом с синхронизированным боковым просмотром',
          desc2: 'Перевод слов: мгновенно переводите выделенные слова одним кликом',
          desc3:
            'Мгновенный перевод: переводите любой текст или предложение на месте для быстрой ясности',
          desc4:
            'Перевод изображений: автоматически заменяйте оригинальные изображения на переведённые',
          desc5: 'Перевод видео: смотрите видео с двуязычными субтитрами для лучшего восприятия',
        },
      },
    },
    question: {
      title: 'Часто задаваемые вопросы',
      answer1: {
        title: 'Можно ли использовать Noam PDF Translator бесплатно для перевода PDF?',
        content:
          'Да, вы можете бесплатно переводить PDF-файлы с помощью Sider PDF Translator! Мы предлагаем бесплатный лимит в 5 000 токенов, чего достаточно для перевода большинства популярных PDF-документов. Если нужно переводить большие файлы или пользоваться расширенными функциями, вы можете перейти на премиум-тариф и получить ещё больше возможностей.',
      },
      answer2: {
        title: 'Насколько точен перевод Noam PDF Translator?',
        content:
          'Noam PDF Translator обеспечивает высокоточный перевод с помощью передовых AI-технологий и глубокого понимания контекста ваших документов. Хотя ни один автоматический перевод не идеален, наша функция бокового сравнения позволяет легко проверять и улучшать каждый перевод, чтобы итоговый результат соответствовал вашим ожиданиям. Попробуйте надёжный и точный перевод PDF с Noam.',
      },
      answer3: {
        title: 'Можно ли переводить отсканированные PDF?',
        content:
          'Да, вы можете переводить отсканированные PDF-файлы с помощью встроенной технологии OCR (оптическое распознавание символов). Наша система автоматически извлекает текст из сканированных документов и PDF на основе изображений, а затем переводит содержимое для вас. Даже не редактируемые или только изображённые PDF можно перевести точно.',
      },
      answer4: {
        title: 'Сколько времени занимает перевод?',
        content:
          'Перевод происходит быстро и эффективно — большинство документов обрабатываются за считанные секунды или минуты, в зависимости от их длины и сложности. Например, стандартный PDF на 10 страниц обычно переводится менее чем за 2 минуты. Оцените быстрые сроки выполнения для всех ваших потребностей в переводе!',
      },
      answer5: {
        title: 'Можно ли сохранить боковой вид для чтения?',
        content:
          'Да, вы всегда можете читать свои документы в режиме бокового сравнения. Такой формат позволяет легко сравнивать оригинал и перевод, обеспечивая удобное и эффективное чтение.',
      },
    },
    freeTrial: 'Бесплатная пробная версия',
    toLanguage: { title: '{{lang}} Пары AI-перевода PDF', item: '{{source}} на {{target}}' },
  },
  aiPdfTranslate: {
    header: {
      features: 'Функции',
      blog: 'Блог',
      button: 'Перевести сейчас',
      pricing: 'Цена',
      faq: 'Часто задаваемые вопросы',
    },
    hero: {
      upload: {
        highlight: 'Нажмите для просмотра',
        max: 'Макс',
        desc: 'или перетащите',
        title: 'Загрузите ваш PDF',
      },
      pill: 'PDF-переводчик на базе искусственного интеллекта',
      title: 'Бесплатный переводчик PDF',
      to: 'к',
      desc: 'Мгновенные, точные переводы с сохранением исходного форматирования. Noam AI поддерживает распознавание текста (OCR) и отображение в режиме «для сравнения».',
      model: 'GPT-4 и Claude',
      support: 'Поддержка OCR',
      free: 'Бесплатная пробная версия',
      translated: 'Переведено Ноамом',
      complete: 'Перевод завершен',
    },
    ticker: {
      pdf: 'Перевод PDF',
      ocr: 'Технология оптического распознавания символов',
      format: 'Сохранение формата',
      multi: 'Многоязычный',
      side: 'Рядом',
      web: 'Веб-перевод',
      secure: 'Безопасно и конфиденциально',
      chat: 'Чат с PDF',
    },
    comparison: {
      bad: {
        title: 'Стандартный перевод',
        head: 'Потеря форматирования и контекста',
        text1: 'Ошибка: разметка нарушена. Изображения расположены некорректно.',
        text2: 'Текст перекрывается, шрифты несовместимы. Трудно читать и непрофессионально...',
      },
      dump: { title: 'Плоский текстовый дамп' },
      good: {
        title: 'Перевод Noam AI',
        sub: 'Идеальное форматирование, учитывающее контекст',
        tag: 'Идеальный результат',
      },
      title: 'Почему выбирают Noam AI?',
      desc: 'Перестаньте мучаться с копипастой переводов. Ощутите разницу между обычными инструментами и нашим AI-переводом с пониманием контекста.',
    },
    showcase: {
      title2: 'Любой язык',
      kicker: 'ПОДДЕРЖИВАЕМЫЕ ДОКУМЕНТЫ',
      title1: 'Любой документ',
      carousel1: 'Искусство',
      carousel2: 'Архитектура',
      carousel3: 'Научный журнал',
      note: 'Легко справляйтесь с техническими, академическими и креативными документами.',
      carousel4: 'Медицина',
      carousel6: 'Закон',
      carousel5: 'Финансы',
      carousel7: 'Договор',
      carousel8: 'Политика',
    },
    features: {
      big: {
        title: 'Продвинутые модели ИИ (GPT-4, Claude)',
        desc: 'Выберите из ведущих моделей искусственного интеллекта, чтобы соответствовать вашим требованиям к переводу. Обеспечьте оптимальные результаты для различных типов документов.',
      },
      grid1: {
        title: 'Поддержка OCR',
        desc: 'Мгновенно извлекайте и переводите текст из отсканированных PDF-файлов и изображений.',
      },
      grid2: {
        title: 'Экспорт в высоком разрешении',
        desc: 'Скачайте переведенные документы в формате PDF с сохранением исходного макета.',
      },
      grid3: {
        title: 'Сравнение бок о бок',
        desc: 'Синхронизированная прокрутка для сравнения оригинального и переведенного текста.',
      },
      title1: 'Не только перевод',
      title2: 'Это революция',
      line1: 'Техническая статья.pdf',
      line2: 'Определение языка: английский...',
      line3: 'Модель: GPT-4o (Высокая точность)',
      line4: 'Перевод завершен (точность 99%)',
    },
    testimonials: {
      review1: {
        role: 'Исследователь',
        content:
          'Noam AI спасла мне часы на перевод академических статей. Дополнительное окно для проверки перевода невероятно полезно для проверки технических терминов.',
      },
      review2: {
        role: 'Глобальный маркетолог',
        content:
          'Лучший переводчик PDF, который я когда-либо использовал. Он идеально сохраняет исходный формат, что критически важно для наших маркетинговых презентаций.',
      },
      review3: {
        role: 'Юридический консультант',
        content:
          'Точный и быстрый. Использую его для перевода договоров, а функция OCR для сканированных документов работает безупречно.',
      },
      title: 'Что говорят наши пользователи',
      kicker: 'ПОЛЬЗОВАТЕЛЯМИ ЛЮБИМЫЙ',
    },
    cta: {
      title: 'Готовились сломать языковые барьеры?',
      button: 'Начните переводить бесплатно',
      desc: 'Присоединяйтесь к более чем 10 000 пользователям и начните переводить свои документы с Noam AI уже сегодня.',
      hint: 'Переведите следующий текст на естественный русский язык:',
    },
    languagePairs: {
      title: 'Пары для ИИ-перевода PDF на английский язык',
      desc: 'Популярные направления перевода, поддерживаемые Noam AI',
    },
    footer: {
      about: 'О нас',
      privacy: 'Политика конфиденциальности',
      contact: 'Связаться со службой поддержки',
    },
  },
}

export default TRANSLATION
